/*
  This page is for Account activation
  Author: Surojit Basu
  Date: Jan 20, 2021
*/
import React,{useEffect,useState,useContext} from 'react';
import {  
  Container,
  Card,
  Row,
  Col,
  Form,
  Button,
  Alert,
  ProgressBar
} from 'react-bootstrap';

import {useParams} from 'react-router-dom';
import {MessageModal} from '../components';
import UserContext from './../contexts/UserContext';
import './login.css';
import Utils from './../Utils';
import _ from 'lodash';

const Activate = (props) => {

  const {goActivate, selectedPackage} = useContext(UserContext);
  const [init,setInit] = useState(false);
  const [loading,setLoading] = useState(false);
  const [message,setMessage] = useState(false);   
  const { code, buy } = useParams();  
  const [stopActivation, setStopActivation ]  = useState(false);
  useEffect(()=>{        
    if(!Utils.isLoggedIn()){
      setInit(false);
      if(!_.isEmpty(code)){
      
        if(buy==='1' && !selectedPackage()) {          
          setStopActivation(true);          
        }
        else{
          confirmActivate({code : code});
        }
        
        
        return;
      }      
    }    
      window.location.href = process.env.PUBLIC_URL + '/builder';
    
  },[]);

  const onSubmit = (e) => {
    var frm = e.currentTarget;
    e.preventDefault();    
  }

  const confirmActivate =(data) =>{
    setLoading(true);
    goActivate(data,(success,message) => {
      setLoading(false);      
      setMessage([success ? 'info' : 'danger',message]);       
      if(success){
        window.setTimeout(function(){
          window.location.href=process.env.PUBLIC_URL + '/login';
        }, 5000);
      }
    });
  }

  return <Container className="h-100 d-flex justify-content-center align-items-center">
    <Card className="card-shadowed">
      <Card.Body>
        <Row>
          <Col><img src={`${process.env.PUBLIC_URL}/images/logo-blk.png`} className="logo" alt="best pdf to scorm converter" /></Col>
        </Row>
        <Row>
          <Col className="header">                          
              We are happy to see you.
          </Col>
        </Row>
        {stopActivation && <Alert variant="danger" className="p-3">
        Please use same browser to activate your account and continue your purchase.
        </Alert> }
        {!stopActivation  && <>
          

          {loading && <Alert variant="light" className="p-3">
            <p className="loading-msg">Activation process</p>
            <ProgressBar variant="info" animated now={100} />
          </Alert>}
          
          {!loading && <>                    
          
                                  
            <Row className="mt-4 mb-4">
              <Col className="text-center">
                <div className={`alert alert-${message[0]} p-5`}>{message[1]}</div>
              </Col>
            </Row>           
            <Row className="mt-4 mb-4">
              <Col className="text-center"><a href={`${process.env.PUBLIC_URL}/${message[0]=== 'info' ? 'login': 'register'}`} ><img src={`${process.env.PUBLIC_URL}/images/go_button.png`} alt="Login" /></a></Col>
            </Row>
        </>}
        
        </>}
      </Card.Body>
    </Card>  
  </Container>

}

export default Activate;